import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import adapter from './adapter'
import service from './service'
import adapterInvitation from '../invitations/adapter'

const initialState = {
  _payload: null,
  status: 'idle',
  error: '',
  data: [],
  data_bookmark: {
    organizations: [],
    programs: [],
    events: [],
    resources: [],
    blogs: []
  },
  organizations: [],
  invitations: [],
  profile_page_data: {},
}

export const fetchIndividu = createAsyncThunk('individu/fetchIndividu', async (id) => {
  const data = await service.getData(id)
  return data
})

export const individuSlice = createSlice({
  name: 'individu',
  initialState,
  reducers: {
    setStatus(state, action){
      state.status = action.payload
    }
  },
  extraReducers: {
    // Bulk
    [fetchIndividu.pending]: (state) => {
      state.status = 'loading'
    },
    [fetchIndividu.fulfilled]: (state, action) => {
      state.status = 'succeeded'
      const { payload } = action
      state._payload = payload
      state.data = {...payload, sosialMedia_on_database: payload.sosialMedia}
      state.profile_page_data = adapter.payloadToProfilePage(payload)
      state.organizations = adapter.payloadToOrganizationList(payload)
      state.data_bookmark = adapter.responseBodyToBookmark(payload)

      // match data structure
      if(payload.invitedByOrganisasi){
        state.invitations = payload.invitedByOrganisasi.map(i => adapterInvitation.responseBodyToIndividuForm(i))
      }
    },
    [fetchIndividu.rejected]: (state, action) => {
      state.status = 'failed'
      state.error = action.error.message
    },
  }
})

export const { setStatus } = individuSlice.actions

export default individuSlice.reducer
